import { action } from '@reatom/framework'

import { PlatformUtil } from '@root/shared'

import { supportAccountLinkAtom } from '../../shared/dependencies'

export * from './reatom-support-dialog'

export const openSupportChatAction = action((ctx) => {
  const link = ctx.get(supportAccountLinkAtom)

  PlatformUtil.openLink(link, '_blank')
}, 'openSupportChatAction')
